// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2rI_N","head":"ProcedureTableInfo_head__3aM7r"};